import {
  SET_LOGIN_AUTH,
  SET_LOGOUT_AUTH,
  INITIALIZE_APP,
  REFRESH_INVENTORY,
  UPDATE_USER_INFO,
  USER_TYPE,
  GROUP_ID,
  DEFAULT_CLINIC_ID,
  UPDATE_USER_PERMISSIONS,
  USER_GROUPS,
  SWITCH_TABS,
  SHOW_MESSAGE_ALERT,
  SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH,
  SET_DEFAULT_TAB_AFTER_AUTH,
  SET_VERIFY_OTP_USER_DETAILS
} from '../actions/Index';

// Defining the initial state for the reducer

interface AuthStateType {
  authToken: null | string;
  initialRoute: string;
  isEnrolledForBioAuth: boolean;
  deviceHasTouchId: boolean;
  deviceHasFaceId: boolean;
  // TODO: add type
  oauth: any;
  // Add type for it
  user: any;
  // TODO: add enum type
  userType: string | null;
  groupId: number | null;
  defaultClinicId: string | null;
  switch_tab: boolean;
  // TODO: Why it is not added in initState below?
  userPermissions?: any;
  userGroups?: any;
  refresh?: any;
  showMessageAlert?: any;
  user_has_admin_role_and_reports_enable?: boolean;
  defaultGroupIdAfterAuth: number | string | null;
  defaultTabAfterAuth: string | null;
  verifyOTPUserDetails: any;
}

const initState: AuthStateType = {
  authToken: null,
  initialRoute: '',
  isEnrolledForBioAuth: false,
  deviceHasTouchId: false,
  deviceHasFaceId: false,
  oauth: null,
  user: {},
  userType: null,
  groupId: null,
  defaultClinicId: null,
  switch_tab: false,
  showMessageAlert: false,
  user_has_admin_role_and_reports_enable: false,
  defaultGroupIdAfterAuth: null,
  defaultTabAfterAuth: null,
  verifyOTPUserDetails: null
};

export default function (state = initState, action: any): AuthStateType {
  const {type, payload} = action;
  switch (type) {
    case SET_LOGIN_AUTH:
      return {
        ...state,
        authToken: payload.authToken,
        initialRoute: payload.initialRoute || '',
        oauth: payload.oauth
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState,
        isEnrolledForBioAuth: state.isEnrolledForBioAuth,
        deviceHasTouchId: state.deviceHasTouchId,
        deviceHasFaceId: state.deviceHasFaceId,
        oauth: null
      };
    case SHOW_MESSAGE_ALERT:
      return {
        ...state,
        showMessageAlert: payload.showMessageAlert
      };
    case INITIALIZE_APP:
      return {...state, ...payload.config};
    case UPDATE_USER_INFO:
      if (payload.data.userInfo) {
        return {...state, user: payload.data.userInfo};
      }
      return state;
    case REFRESH_INVENTORY:
      return {...state, refresh: payload.refresh};
    case USER_TYPE:
      return {
        ...state,
        userType: payload.userType
      };
    case GROUP_ID:
      return {
        ...state,
        groupId: payload.groupId
      };
    case DEFAULT_CLINIC_ID:
      return {
        ...state,
        defaultClinicId: payload.defaultClinicId
      };
    case UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        userPermissions: payload.data.userPermissions
      };
    case USER_GROUPS:
      return {
        ...state,
        userGroups: payload.userOrgGroupList
      };
    case SWITCH_TABS:
      return {
        ...state,
        switch_tab: payload.switch_tab
      };
    case SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH: {
      return {
        ...state,
        defaultGroupIdAfterAuth: payload.clinic_group_id
      };
    }
    case SET_DEFAULT_TAB_AFTER_AUTH: {
      return {
        ...state,
        defaultTabAfterAuth: payload.tab
      };
    }
    case SET_VERIFY_OTP_USER_DETAILS: {
      return {
        ...state,
        verifyOTPUserDetails: payload.user
      };
    }
    default:
      return state;
  }
}
